'use strict';

var createMiddleware = require('./middleware');
var combineSubscribers = require('./combineSubscribers');

var _require = require('./commands'),
    createImmediateCmd = _require.createImmediateCmd,
    createQueuedCmd = _require.createQueuedCmd;

var _require2 = require('./action'),
    matchAction = _require2.match;

module.exports.createMiddleware = createMiddleware;
module.exports.combineSubscribers = combineSubscribers;
module.exports.createImmediateCmd = createImmediateCmd;
module.exports.createQueuedCmd = createQueuedCmd;

module.exports.matchAction = matchAction;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/index.js
// module id = 18
// module chunks = 0